module.exports = __webpack_public_path__ + "img/3_x6.018cdd93.png";